module.exports = __webpack_public_path__ + "img/ax2-logo.779edc83.svg";